import {
  AppBar,
  Box,
  Button,
  Container,
  Divider,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

type MarketingShellProps = {
  children: React.ReactNode;
  fullBleed?: boolean;
};

export const MarketingShell = ({ children, fullBleed = false }: MarketingShellProps) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        color: "#f8fafc",
        background:
          "radial-gradient(circle at 10% -5%, rgba(45,212,191,0.25), transparent 36%), radial-gradient(circle at 88% 8%, rgba(56,189,248,0.2), transparent 34%), radial-gradient(circle at 50% 100%, rgba(13,148,136,0.16), transparent 42%), #020617",
      }}
    >
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: "rgba(2,6,23,0.72)",
          backdropFilter: "blur(16px)",
          borderBottom: "1px solid rgba(148,163,184,0.2)",
        }}
      >
        <Toolbar sx={{ maxWidth: 1180, width: "100%", mx: "auto", py: 0.7 }}>
          <Stack direction="row" alignItems="center" spacing={1.2} sx={{ flexGrow: 1 }}>
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: 2,
                border: "1px solid rgba(45,212,191,0.45)",
                background:
                  "linear-gradient(135deg, rgba(45,212,191,0.26), rgba(56,189,248,0.28))",
                display: "grid",
                placeItems: "center",
                color: "#ccfbf1",
                fontWeight: 900,
                letterSpacing: "-0.02em",
              }}
            >
              S
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 900, letterSpacing: "-0.02em", lineHeight: 1.1 }}>
                Symplou
              </Typography>
              <Typography sx={{ fontSize: 12, color: "rgba(226,232,240,0.68)", lineHeight: 1.1 }}>
                Plataforma inteligente para varejo
              </Typography>
            </Box>
          </Stack>
          <Stack direction="row" spacing={0.5}>
            <Button component={RouterLink} to="/" sx={{ color: "#e2e8f0", fontWeight: 700 }}>
              Home
            </Button>
            <Button component="a" href="/#recursos" sx={{ color: "#e2e8f0", fontWeight: 700 }}>
              Recursos
            </Button>
            <Button
              component={RouterLink}
              to="/planos"
              sx={{ color: "#e2e8f0", fontWeight: 700 }}
            >
              Planos
            </Button>
            <Button
              component={RouterLink}
              to="/entrar"
              variant="contained"
              sx={{
                fontWeight: 800,
                background: "linear-gradient(135deg, #2dd4bf, #0d9488)",
                "&:hover": { background: "linear-gradient(135deg, #5eead4, #14b8a6)" },
              }}
            >
              Entrar
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>

      {fullBleed ? children : (
        <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
          {children}
        </Container>
      )}

      <Box sx={{ mt: 4, borderTop: "1px solid rgba(148,163,184,0.18)" }}>
        <Container maxWidth="lg" sx={{ py: 3 }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            spacing={2}
            sx={{ color: "rgba(226,232,240,0.75)" }}
          >
            <Box>
              <Typography sx={{ fontWeight: 800, color: "#e2e8f0", mb: 0.5 }}>Symplou</Typography>
              <Typography sx={{ fontSize: 13 }}>
                Gestão comercial modular, visual e orientada por dados.
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: 13 }}>Institucional premium do ecossistema Symplou.</Typography>
            </Box>
          </Stack>
          <Divider sx={{ my: 2, borderColor: "rgba(148,163,184,0.15)" }} />
          <Typography
            sx={{
              textAlign: "center",
              color: "rgba(226,232,240,0.62)",
              fontSize: 12,
            }}
          >
            Symplou - Plataforma modular para varejo e atacado
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};
